/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One user_session_issuer setting whose source and target values differ.
 */
export type UserSessionIssuerFieldMismatch = {
  /**
   * The differing field name.
   */
  field: string;
  /**
   * The source issuer's rendered value. Empty when unset.
   */
  sourceValue: string;
  /**
   * The target issuer's rendered value. Empty when unset.
   */
  targetValue: string;
};

/** @internal */
export const UserSessionIssuerFieldMismatch$inboundSchema: z.ZodMiniType<
  UserSessionIssuerFieldMismatch,
  unknown
> = z.pipe(
  z.object({
    field: z.string(),
    source_value: z.string(),
    target_value: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "source_value": "sourceValue",
      "target_value": "targetValue",
    });
  }),
);

export function userSessionIssuerFieldMismatchFromJSON(
  jsonString: string,
): SafeParseResult<UserSessionIssuerFieldMismatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserSessionIssuerFieldMismatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserSessionIssuerFieldMismatch' from JSON`,
  );
}
